( function( $ ) {
	let initBlock = function() {
		let $tabs = $( '.section-woo-product-tabs' );

		if ( !$tabs.length ) {
			return;
		}

		window.app.main.horizontalScroll( '.section-woo-product-tabs' );

		$tabs.find( '.tab-entry__heading a' ).on( 'click', function() {
			$tabs.find( '.tab-entry__heading--active' ).removeClass( 'tab-entry__heading--active' );
			$tabs.find( '.section-woo-product-tabs__entry--active' ).removeClass( 'section-woo-product-tabs__entry--active' );

			let newTabIndex = $( this ).parent().index();

			$tabs.find( '.tab-entry__heading' ).eq( newTabIndex ).addClass( 'tab-entry__heading--active' );
			$tabs.find( '.section-woo-product-tabs__entry' ).eq( newTabIndex ).addClass( 'section-woo-product-tabs__entry--active' );
		} );
	};

	window.app.loadBlock( initBlock, 'section-woo-product-tabs', '.section-woo-product-tabs' );

} )( jQuery );